import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidationErrors, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AnalyticValidators } from 'src/app/core/validators/analytic.validators';
import { AnalyticEdit } from '../model/analyticEdit';

@Component({
  standalone: false,
  selector: 'app-analytic-edit',
  templateUrl: './analytic-edit.component.html',
  styleUrls: ['./analytic-edit.component.scss']
})
export class AnalyticEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<AnalyticEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;

  public urlPattern = /^(?:https?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

  private analyticEdit: AnalyticEdit;

  constructor(
    private fb: UntypedFormBuilder,
    private analyticValidators: AnalyticValidators) { }

  public get name(): UntypedFormControl
  {
    return this.editForm.get('name');
  }

  public get description(): UntypedFormControl
  {
    return this.editForm.get('description');
  }

  public get link(): UntypedFormControl
  {
    return this.editForm.get('link');
  }

  public get enabled(): UntypedFormControl
  {
    return this.editForm.get('enabled');
  }

  @Input() public set model(analytic: AnalyticEdit)
  {
    this.initModel(analytic);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();
    const objectToPersist = this.editForm.value;

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  public isValidUri(uri: UntypedFormControl): boolean
  {
    const regEx = new RegExp(this.urlPattern);
    return uri.value !== undefined && uri.value && regEx.test(uri.value);
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(analyticEdit: AnalyticEdit)
  {
    if (analyticEdit === undefined)
    {
      return;
    }

    // Set the current analytic id used for name async validators
    const previousAnalyticName = this.isNew ? '' : analyticEdit.name;

    const urlValidatorsRequired = [
      Validators.required,
      Validators.pattern(this.urlPattern)
    ];

    // Set form
    this.editForm = this.fb.group({
      id: [analyticEdit.id],
      version: [analyticEdit.version],
      name: [
        { value: '', disabled: false },
        {
          validators: [Validators.required],
          asyncValidators: (): Observable<ValidationErrors | null> =>
            this.analyticValidators.validateAnalyticNameUnique(this.editForm.get('name'), previousAnalyticName)
        }
      ],
      link: [
        { value: analyticEdit.link, disabled: false },
        {
          validators: urlValidatorsRequired
        }
      ],
      description: { value: analyticEdit.description, disabled: false },
      enabled: [analyticEdit.enabled !== null ? analyticEdit.enabled : true, Validators.required],
    });

    this.editForm.reset(analyticEdit);
    this.analyticEdit = analyticEdit;
    this.editFormActive = analyticEdit !== undefined;
  }
}
